module.exports = __webpack_public_path__ + "static/media/Farley.de99912d.png";